import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface RoleProtectedRouteProps {
  allowedRoles: string[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ allowedRoles }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // The parent ProtectedRoute already handles the !isAuthenticated case.
  // This component just checks for authorization (role).
  if (!user || !allowedRoles.includes(user.role)) {
    // User is logged in but doesn't have the required role.
    // Redirect to a safe page, like the main dashboard.
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default RoleProtectedRoute;